import {Pipe, Injectable, PipeTransform} from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser'

/**
 * Generated class for the KeywordsPipe pipe.
 *
 * See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 * Angular Pipes.
 */
@Pipe({
  name: 'keywords',
})
export class KeywordsPipe implements PipeTransform {
  constructor(private sanitizer:DomSanitizer){

  }
 
  transform(content: string, key:string):any {
    //alert("key=" + key + ",content=" + content);
    let Reg=new RegExp(key, "i");//i表示对大小写不敏感
    //let Reg=new RegExp(key, "g");//查找所有匹配而非在找到第一个匹配后停止
    if(content){
      let res = content.replace( Reg,`<span style="color: #ff2424;">${key?key:''}</span>`);
      return this.sanitizer.bypassSecurityTrustHtml(res);
    }

  }
}



// WEBPACK FOOTER //
// ./src/pipes/keywords/keywords.ts